// Live Preview Types

export interface WhatsAppMessage {
  id: string;
  sender: string;
  content: string;
  timestamp: string;
  message_type: 'text' | 'image' | 'video' | 'audio' | 'document' | 'system';
  is_media: boolean;
  is_edited: boolean;
  media_file?: string;
  media_url?: string;
  media_thumb_url?: string;
}

export interface PreviewOptions {
  // Header
  exportTitle: string;
  showHeader: boolean;
  showHeaderParticipants: boolean;
  showHeaderStats: boolean;

  // Display
  showSystemMessages: boolean;
  showDateHeaders: boolean;
  showTimestamps: boolean;
  showSenderNames: boolean;
  showEditMarkers: boolean; // Show/hide <Diese Nachricht wurde bearbeitet.>
  
  // Colors
  exporteurColor: string;
  otherColor: string;
  systemColor: string;
  accentColor: string;
  backgroundColor: string; // Chat background color
  showWhatsAppBackground: boolean;
  
  // Layout
  bubbleStyle: 'rounded' | 'square';
  bubbleSize: 'compact' | 'normal' | 'wide';
  fontSize: 'small' | 'normal' | 'large';
  lineHeight: 'compact' | 'normal' | 'wide';
  
  // Media
  mediaMode: 'thumbnail' | 'link' | 'both' | 'hidden' | 'hosting';
  thumbnailSize: 'small' | 'normal' | 'large';
  showVideoOverlay: boolean;
  
  // Filter
  dateRange: { from: Date | null; to: Date | null };
  selectedSenders: string[];
  mediaFilter: ('image' | 'video' | 'audio' | 'document')[];
  searchText: string;
}

export interface ChatStats {
  totalMessages: number;
  participants: string[];
  exporteur: string; // detected by no phone number
  mediaCount: number;
  dateRange: { start: Date; end: Date };
}

/** Prüfergebnis des Parsers. Blockiert nie den Kauf — warnt nur ehrlich. */
export interface ParseQuality {
  quality: 'ok' | 'warn' | 'poor';
  warnings: string[];
}

export const defaultOptions: PreviewOptions = {
  // Header
  exportTitle: 'WhatsApp Chat Export',
  showHeader: true,
  showHeaderParticipants: true,
  showHeaderStats: true,

  // Display
  showSystemMessages: false,
  showDateHeaders: true,
  showTimestamps: true,
  showSenderNames: true,
  showEditMarkers: true, // Show <Diese Nachricht wurde bearbeitet.> markers
  
  // Colors (WhatsApp defaults)
  exporteurColor: '#dcf8c6', // Light green
  otherColor: '#ffffff',     // White
  systemColor: '#e1f5fe',    // Light cyan (matches PDF rgba(225, 245, 254, 0.92))
  accentColor: '#00a884',    // WhatsApp green
  backgroundColor: '#e5ddd5', // Match PDF background
  showWhatsAppBackground: false,
  
  // Layout
  bubbleStyle: 'rounded',
  bubbleSize: 'normal',
  fontSize: 'normal',
  lineHeight: 'normal',
  
  // Media
  mediaMode: 'thumbnail',
  thumbnailSize: 'normal',
  showVideoOverlay: true,
  
  // Filter - default to showing all media types
  dateRange: { from: null, to: null },
  selectedSenders: [],
  mediaFilter: ['image', 'video', 'audio', 'document'],
  searchText: '',
};
